import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TransactionPage from './pages/TransactionPage';
import TemplatePreview from './pages/TemplatePreview';
import AppLayout from './ui/AppLayout';

// Витрина шаблонов и экранов без живого тикета — только dev-сборка, в прод роут не попадает.
const isDev = process.env.NODE_ENV !== 'production';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {isDev && <Route path='/preview' element={<TemplatePreview />} />}
        <Route element={<AppLayout />}>
          <Route path='/:uuid' element={<TransactionPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
